import { useSessionStore, isAdminRole } from '@room/shared-ui';

export const adminTileVisible = () => {
  const role = useSessionStore.getState().user?.role;
  return isAdminRole(role);
};
